import { axiosInstance } from "./BaseService";

const ASSORTMENT_URL = '/assortment';

export const fetchFinancialSummary = async () => {
  try {
    const financialSummaryUrl = `${ASSORTMENT_URL}/financial-summary`;

    const response = await axiosInstance.get(financialSummaryUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchProductReportPerformance = async () => {
  try {
    const productPerformanceSummaryUrl = `${ASSORTMENT_URL}/product-performance-summary`;

    const response = await axiosInstance.get(productPerformanceSummaryUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchCollectionPrediction = async () => {
  try {
    const collectionPredictionUrl = `${ASSORTMENT_URL}/collection-prediction`;

    const response = await axiosInstance.get(collectionPredictionUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchHistoricalMatrix = async () => {
  try {
    const historicalMatrixUrl = `${ASSORTMENT_URL}/historical-matrix`;

    const response = await axiosInstance.get(historicalMatrixUrl);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchProductImage = async (productId) => {
  try {
    const response = await axiosInstance.get(`${ASSORTMENT_URL}/product/image/${productId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchProductTag = async (seasonId, productId) => {
  try {
    const response = await axiosInstance.get(`${ASSORTMENT_URL}/product/tag/${seasonId}/${productId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const fetchProductImagesByIds = async (seasonId, productIds) => {
  try {
    const response = await axiosInstance.post(`${ASSORTMENT_URL}/product/pdf/${seasonId}`, { productIds });
    return response.data;
  } catch (err) {
    throw err;
  }
};